import { useTranslation } from "react-i18next";
import { Account, ZuoraPaymentMethodTypes, Location } from "@/api/opb/opbTypes";

import { BacsDirectDebit } from "@/resources/svg";
import StripePaymentMethodDrawerForm from "./StripePaymentMethodDrawerForm";

interface AddBacsAccountStripeFormProps {
  account: Account;
  accountLocation?: Location;
  isDefaultPaymentChecked: boolean;
  setIsDefaultPaymentChecked: (checked: boolean) => void;
}

export function AddBacsAccountStripeForm({
  account,
  accountLocation,
  isDefaultPaymentChecked,
  setIsDefaultPaymentChecked,
}: AddBacsAccountStripeFormProps) {
  const { t } = useTranslation("paymentMethods");

  const renderPaymentMethodInformation = () => (
    <div className="w-full">
      <div className="mt-4 text-sm text-black font-normal">
        {t(
          "You will be notified 3 working days in advance of any change to the amount, date, or frequency of your Direct Debit"
        )}
      </div>
      <div className="flex flex-row items-end justify-between mt-4">
        <div className="text-grey-25 text-sm font-bold">
          {t("The Direct Debit Guarantee")}
        </div>
        <img
          src={BacsDirectDebit}
          alt={t("Direct Debit logo")}
          className="w-[140px]"
        />
      </div>
      <ul className="list-inside mt-4 text-grey-25 text-sm font-normal">
        <li>{t("direct-debit-bullet-1")}</li>
        <li>{t("direct-debit-bullet-2")}</li>
        <li>
          {t("direct-debit-bullet-3")}
          <ul className="list-inside pl-4">
            <li>{t("direct-debit-bullet-4")}</li>
          </ul>
        </li>
        <li>{t("direct-debit-bullet-5")}</li>
      </ul>
      {accountLocation ? (
        <div className="flex flex-col mt-4 text-grey-25 text-sm font-normal">
          {accountLocation?.locationsLegalEntityName ? (
            <div>{accountLocation.locationsLegalEntityName}</div>
          ) : null}
          {accountLocation.address}
          {accountLocation?.address2 ? (
            <div>{accountLocation.address2}</div>
          ) : null}
          <div>
            {`${accountLocation.city}, ${accountLocation.country} ${accountLocation.zipCode}`}
          </div>
          {accountLocation?.email ? (
            <a
              href={`mailto:${accountLocation.email}`}
              target="_blank"
              rel="noreferrer noopener"
              className="underline"
            >
              {accountLocation.email}
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  );

  return (
    <StripePaymentMethodDrawerForm
      accountId={account._id}
      paymentType={ZuoraPaymentMethodTypes.Bacs}
      currencyIsoCode={accountLocation?.currencyCode}
      paymentMethodInformation={renderPaymentMethodInformation}
      submitLabel={t("Confirm Direct Debit")}
      isDefaultPaymentChecked={isDefaultPaymentChecked}
      setIsDefaultPaymentChecked={setIsDefaultPaymentChecked}
    />
  );
}
